import React, { useState, useEffect } from 'react';

const MillionaireGame = () => {
  // Инициализация Telegram WebApp
  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.expand(); // Расширяем на весь экран
      tg.ready(); // Сообщаем, что приложение загружено

      // Настраиваем кнопку назад
      tg.BackButton.show();
      tg.BackButton.onClick(() => {
        if (gameState !== 'playing') {
          restartGame();
        } else {
          if (window.confirm('Вы уверены, что хотите выйти из игры?')) {
            tg.close();
          }
        }
      });

      return () => {
        tg.BackButton.hide();
      };
    }
  }, []);

  // Массив вопросов с вариантами ответов и указанием правильного ответа
  const questions = [
    {
      question: 'Когда празднуется Наурыз?',
      options: ['1 января', '22 марта', '1 мая', '31 декабря'],
      correctAnswer: '22 марта',
      prize: '100'
    },
    {
      question: 'Что символизирует праздник Наурыз?',
      options: ['Начало нового года', 'Сбор урожая', 'День независимости', 'Религиозный праздник'],
      correctAnswer: 'Начало нового года',
      prize: '200'
    },
    {
      question: 'Какое традиционное блюдо готовят на Наурыз?',
      options: ['Плов', 'Бешбармак', 'Наурыз-коже', 'Шашлык'],
      correctAnswer: 'Наурыз-коже',
      prize: '300'
    },
    {
      question: 'Сколько компонентов традиционно входит в Наурыз-коже?',
      options: ['3', '5', '7', '9'],
      correctAnswer: '7',
      prize: '500'
    },
    {
      question: 'В каких странах официально празднуют Наурыз?',
      options: ['Только в Казахстане', 'В странах Центральной Азии', 'В странах СНГ', 'Во всех тюркских и иранских государствах'],
      correctAnswer: 'Во всех тюркских и иранских государствах',
      prize: '1 000'
    },
    {
      question: 'Как называется праздник весеннего равноденствия у персов?',
      options: ['Новруз', 'Наурыз', 'Хыдырлез', 'Сабантуй'],
      correctAnswer: 'Новруз',
      prize: '2 000'
    },
    {
      question: 'Какая традиционная игра проводится на Наурыз?',
      options: ['Шахматы', 'Кокпар', 'Городки', 'Лапта'],
      correctAnswer: 'Кокпар',
      prize: '4 000'
    },
    {
      question: 'Что означает слово "Наурыз" в переводе?',
      options: ['Новый день', 'Новый год', 'Новый месяц', 'Новая весна'],
      correctAnswer: 'Новый день',
      prize: '8 000'
    },
    {
      question: 'Какой музыкальный инструмент традиционно используется во время празднования Наурыза?',
      options: ['Балалайка', 'Домбра', 'Гармонь', 'Барабан'],
      correctAnswer: 'Домбра',
      prize: '16 000'
    },
    {
      question: 'Какое дерево традиционно сажают в день Наурыза?',
      options: ['Яблоня', 'Сосна', 'Дуб', 'Берёза'],
      correctAnswer: 'Яблоня',
      prize: '32 000'
    },
    {
      question: 'Сколько дней традиционно длится празднование Наурыза?',
      options: ['1 день', '3 дня', '7 дней', '40 дней'],
      correctAnswer: '3 дня',
      prize: '64 000'
    },
    {
      question: 'В каком году ЮНЕСКО включил Наурыз в список нематериального культурного наследия человечества?',
      options: ['2005', '2009', '2010', '2015'],
      correctAnswer: '2009',
      prize: '125 000'
    },
    {
      question: 'Какое животное является символом 2022 года по восточному календарю, который используется во время празднования Наурыза?',
      options: ['Тигр', 'Бык', 'Дракон', 'Змея'],
      correctAnswer: 'Тигр',
      prize: '250 000'
    },
    {
      question: 'Какой обряд связан с перепрыгиванием через костёр во время празднования Наурыза?',
      options: ['Айтыс', 'Аластау', 'Беташар', 'Шашу'],
      correctAnswer: 'Аластау',
      prize: '500 000'
    },
    {
      question: 'Как называется специальное юрточное поселение, которое устанавливают в городах во время празднования Наурыза?',
      options: ['Кииз-уй', 'Наурыз-кент', 'Этноаул', 'Орда'],
      correctAnswer: 'Этноаул',
      prize: '1 000 000'
    }
  ];

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [gameState, setGameState] = useState('playing'); // 'playing', 'correct', 'wrong', 'won'
  const [usedLifelines, setUsedLifelines] = useState({
    fifty: false,
    audience: false,
    call: false
  });
  const [prizeWon, setPrizeWon] = useState('0');
  const [eliminatedOptions, setEliminatedOptions] = useState([]);

  const currentQuestion = questions[currentQuestionIndex];

  // Обработка выбора ответа
  const handleOptionSelect = (option) => {
    if (gameState !== 'playing' || eliminatedOptions.includes(option)) return;
    
    setSelectedOption(option);
    
    // Проверка правильности ответа
    if (option === currentQuestion.correctAnswer) {
      setGameState('correct');
      setPrizeWon(currentQuestion.prize);
      
      // Если это был последний вопрос, игра выиграна
      if (currentQuestionIndex === questions.length - 1) {
        setTimeout(() => {
          setGameState('won');
        }, 2000);
      }
    } else {
      // Неверный ответ - конец игры
      setGameState('wrong');
    }
  };

  // Переход к следующему вопросу
  const nextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setSelectedOption(null);
      setGameState('playing');
      setEliminatedOptions([]);
    }
  };

  // Использование подсказки "50/50"
  const useFiftyFifty = () => {
    if (usedLifelines.fifty || gameState !== 'playing') return;
    
    const correctAnswer = currentQuestion.correctAnswer;
    const wrongOptions = currentQuestion.options.filter(option => option !== correctAnswer);
    
    // Случайно выбираем 2 неправильных варианта для удаления
    const shuffled = wrongOptions.sort(() => 0.5 - Math.random());
    const toEliminate = shuffled.slice(0, 2);
    
    setEliminatedOptions(toEliminate);
    setUsedLifelines({ ...usedLifelines, fifty: true });
  };

  // Использование подсказки "Помощь зала"
  const useAudienceHelp = () => {
    if (usedLifelines.audience || gameState !== 'playing') return;
    setUsedLifelines({ ...usedLifelines, audience: true });
    
    // Имитация подсказки зала - в реальной игре здесь бы показывались проценты
    alert(`Зал считает, что правильный ответ: ${currentQuestion.correctAnswer}`);
  };

  // Использование подсказки "Звонок другу"
  const usePhoneCall = () => {
    if (usedLifelines.call || gameState !== 'playing') return;
    setUsedLifelines({ ...usedLifelines, call: true });
    
    // Имитация звонка другу
    alert(`Ваш друг говорит, что правильный ответ: ${currentQuestion.correctAnswer}`);
  };

  // Начать игру заново
  const restartGame = () => {
    setCurrentQuestionIndex(0);
    setSelectedOption(null);
    setGameState('playing');
    setUsedLifelines({
      fifty: false,
      audience: false,
      call: false
    });
    setPrizeWon('0');
    setEliminatedOptions([]);
  };

  // Отправка результатов в Telegram
  const shareResults = () => {
    if (window.Telegram && window.Telegram.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.sendData(JSON.stringify({
        prize: prizeWon,
        questionsAnswered: currentQuestionIndex + 1
      }));
    } else {
      alert(`Ваш выигрыш: ${prizeWon}`);
    }
  };

  // Стили для кнопок ответов
  const getOptionStyle = (option) => {
    let style = "p-2 m-1 rounded border border-gray-300 text-center cursor-pointer w-full";
    
    if (eliminatedOptions.includes(option)) {
      return style + " opacity-50 cursor-not-allowed bg-gray-300";
    }
    
    if (selectedOption === option) {
      style += " bg-yellow-500";
    }
    
    if (gameState === 'correct' && option === currentQuestion.correctAnswer) {
      style = "p-2 m-1 rounded border border-green-500 text-center w-full bg-green-500 text-white";
    }
    
    if (gameState === 'wrong') {
      if (option === selectedOption) {
        style = "p-2 m-1 rounded border border-red-500 text-center w-full bg-red-500 text-white";
      }
      if (option === currentQuestion.correctAnswer) {
        style = "p-2 m-1 rounded border border-green-500 text-center w-full bg-green-500 text-white";
      }
    }
    
    return style;
  };

  return (
    <div className="max-w-3xl mx-auto p-4 bg-blue-900 text-white rounded-lg shadow-lg">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold mb-2">Кто хочет стать миллионером</h1>
        <h2 className="text-xl">Тема: Наурыз</h2>
        <p className="text-yellow-400 mt-4 text-2xl">
          {gameState === 'won' 
            ? `Поздравляем! Вы выиграли 1 000 000!` 
            : `Текущий выигрыш: ${prizeWon}`}
        </p>
      </div>
      
      {gameState === 'won' ? (
        <div className="text-center">
          <h3 className="text-2xl mb-4">Вы победили!</h3>
          <button
            onClick={shareResults}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded mb-4"
          >
            Поделиться результатом
          </button>
          <button
            onClick={restartGame}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded"
          >
            Играть снова
          </button>
        </div>
      ) : gameState === 'wrong' ? (
        <div className="text-center">
          <h3 className="text-xl mb-4">Игра окончена</h3>
          <p className="mb-4">Вы ответили неправильно.</p>
          <p className="mb-4">Ваш выигрыш: {prizeWon}</p>
          <button
            onClick={shareResults}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded mb-4"
          >
            Поделиться результатом
          </button>
          <button
            onClick={restartGame}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded"
          >
            Играть снова
          </button>
        </div>
      ) : (
        <>
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-2">Вопрос {currentQuestionIndex + 1} за {currentQuestion.prize}</h3>
            <div className="bg-blue-800 p-4 rounded-lg">
              <p className="text-xl">{currentQuestion.question}</p>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-6">
            {currentQuestion.options.map((option, index) => (
              <div
                key={index}
                className={getOptionStyle(option)}
                onClick={() => handleOptionSelect(option)}
              >
                {String.fromCharCode(65 + index)}: {option}
              </div>
            ))}
          </div>
          
          {gameState === 'correct' && (
            <div className="text-center mb-6">
              <p className="text-green-400 text-xl mb-4">Правильно!</p>
              <button
                onClick={nextQuestion}
                className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded"
              >
                Следующий вопрос
              </button>
            </div>
          )}
          
          <div className="flex justify-center space-x-4 mb-4">
            <button
              onClick={useFiftyFifty}
              className={`px-2 py-1 rounded ${usedLifelines.fifty ? 'bg-gray-700 cursor-not-allowed' : 'bg-yellow-500 hover:bg-yellow-600'}`}
              disabled={usedLifelines.fifty}
            >
              50/50
            </button>
            <button
              onClick={useAudienceHelp}
              className={`px-2 py-1 rounded ${usedLifelines.audience ? 'bg-gray-700 cursor-not-allowed' : 'bg-yellow-500 hover:bg-yellow-600'}`}
              disabled={usedLifelines.audience}
            >
              Помощь зала
            </button>
            <button
              onClick={usePhoneCall}
              className={`px-2 py-1 rounded ${usedLifelines.call ? 'bg-gray-700 cursor-not-allowed' : 'bg-yellow-500 hover:bg-yellow-600'}`}
              disabled={usedLifelines.call}
            >
              Звонок другу
            </button>
          </div>
        </>
      )}
      
      <div className="mt-6">
        <h3 className="text-lg font-semibold mb-2">Шкала выигрышей:</h3>
        <div className="bg-blue-800 p-2 rounded-lg">
          <div className="grid grid-cols-3 gap-1">
            {questions.slice().reverse().map((q, idx) => {
              const actualIdx = questions.length - 1 - idx;
              const isCurrentQuestion = actualIdx === currentQuestionIndex;
              const isPassed = actualIdx < currentQuestionIndex;
              
              return (
                <div
                  key={idx}
                  className={`p-1 rounded text-center text-sm ${
                    isCurrentQuestion
                      ? 'bg-yellow-500 text-black font-bold'
                      : isPassed
                      ? 'bg-green-700'
                      : 'bg-blue-700'
                  }`}
                >
                  {q.prize}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MillionaireGame;